const fakeComments = [
    {    
        _id: "64244244907873df3d39b4d3",
        userId: "64243d78907873df3d39b488",
        author:"Adeline",
        postId: "64243f9c907873df3d39b4b7",
        title: "Collecte d'après-midi",
        content: "Je suis retournée avec mon mari collecté encore un peu de déchets ! on va y arriver",
        trash_quantity_collected: 40,
        createdAt: "2023-03-29T13:51:00.348+00:00",
        updatedAt: "2023-03-29T13:51:00.348+00:00"
    }
]

export default fakeComments;